import { useEffect, useState } from 'react';
import LoginScreen from '@app/screens/Login/Login';
import LoginOTPScreen from '@app/screens/LoginOTP/OTP';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import ROUTE from './routes';
import { PublicStackParamList } from './types';
import GetStarted from '@app/screens/GetStarted/GetStarted';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import BootSplash from "react-native-bootsplash";

const Stack = createNativeStackNavigator<PublicStackParamList>();

const PublicRoutes = () => {

  const [isLoading, setIsLoading] = useState(true); 
  const [shownGetStarted, setShownGetStarted] = useState(false);

  useEffect(() => {
    const checkGetStarted = async () => {
      if (Platform.OS === 'web') {
        setIsLoading(false);
        return;
      }
      try {
        const value = await AsyncStorage.getItem('first_time');
        setShownGetStarted(value === 'true');
      } catch (error) {
        console.error("Error checking AsyncStorage", error);
      } finally {
        setIsLoading(false);
        // BootSplash.hide({ fade: true });
      }
    };
  
    checkGetStarted();
  }, []);


  if(isLoading) {
    // this will never be shown as splash will be kept on till this part
    // this is to let the initialRouteName resolve properly
    return null;
  }

  return (
    <Stack.Navigator 
      initialRouteName={(!shownGetStarted && Platform.OS !== 'web') ? 'GET_STARTED' : ROUTE.LOGIN_MOBILE_NUMBER_SCREEN}
      screenOptions={{
        title: 'Volt - Unlock cash from your mutual funds saving',
        // animation: 'slide_from_right', // iOS-like horizontal slide animation
        // gestureEnabled: true,         // Enable swipe gestures
        // gestureDirection: 'horizontal',
      }}>
      <Stack.Screen
        name="GET_STARTED"
        component={GetStarted}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LOGIN_MOBILE_NUMBER_SCREEN}
        component={LoginScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LOGIN_OTP_SCREEN}
        component={LoginOTPScreen}
        options={{ headerShown: false }}
      />
    </Stack.Navigator>
  );
};
export default PublicRoutes;
